import { render, staticRenderFns } from "./quotePriceSetting.vue?vue&type=template&id=fdeb74de&scoped=true"
import script from "./quotePriceSetting.vue?vue&type=script&lang=js"
export * from "./quotePriceSetting.vue?vue&type=script&lang=js"
import style0 from "./quotePriceSetting.vue?vue&type=style&index=0&id=fdeb74de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeb74de",
  null
  
)

export default component.exports